import { useDeleteTeamMutation } from '../api/client'
import ConfirmModal from './ConfirmModal'

type Props = {
    setVisible: (visible: boolean) => void
    teamId: number
    userCount: number
    accountCount: number
    onDeleted: () => void
}

function DeleteTeamModal(props: Props) {
    const { setVisible, teamId, userCount, accountCount, onDeleted } = props

    const [deleteTeamMutation, { loading }] = useDeleteTeamMutation()

    const handleDeleteClick = async () => {
        await deleteTeamMutation({
            variables: { teamId, force: true },
            onCompleted: () => {
                onDeleted()
                setVisible(false)
            }
        })
    }

    return (
        <ConfirmModal
            open={true}
            onClose={() => setVisible(false)}
            onConfirm={handleDeleteClick}
            title="Delete team"
            description={
                <p>
                    This team has{' '}
                    <span className="font-semibold text-ink-700">
                        {userCount} {userCount === 1 ? 'user' : 'users'}
                    </span>{' '}
                    who will be disconnected and{' '}
                    <span className="font-semibold text-ink-700">
                        {accountCount} {accountCount === 1 ? 'account' : 'accounts'}
                    </span>{' '}
                    that will be permanently deleted. This action cannot be undone. Users can be
                    deleted from the User Admin screen.
                </p>
            }
            confirmLabel="Delete anyway"
            loading={loading}
        />
    )
}

export default DeleteTeamModal
